import { useCompare } from "../../context/CompareContext";

const CompareFooter = () => {
    const { navigateToCompare, selectedCount } = useCompare();
    return (
        <>
            <div className="d-flex justify-content-end">
                <button
                    className="btn btn-primary"
                    onClick={navigateToCompare}
                    disabled={selectedCount <= 1}
                >
                    مقایسه {selectedCount}/4 محصول
                </button>
            </div>
        </>
    )
}

export default CompareFooter;